import { tracked } from '@glimmer/tracking';

export type ILogonParams = {
  serviceName: string;
  wallpaperPortrait: string;
  wallpaperLandscape: string;
  useWallpapers: boolean;
  online: boolean;
  allowPasskeys: boolean;
};

export default class LogonParams {
  @tracked serviceName: string;
  @tracked wallpaperPortrait: string;
  @tracked wallpaperLandscape: string;
  @tracked useWallpapers: boolean;
  @tracked online: boolean;
  @tracked allowPasskeys: boolean;

  constructor(hash: ILogonParams) {
    this.serviceName = hash.serviceName;
    this.wallpaperPortrait = hash.wallpaperPortrait;
    this.wallpaperLandscape = hash.wallpaperLandscape;
    this.useWallpapers = hash.useWallpapers;
    this.online = hash.online;
    this.allowPasskeys = hash.allowPasskeys;
  }

  update(hash: ILogonParams): void {
    if (this.serviceName !== hash.serviceName) {
      this.serviceName = hash.serviceName;
    }
    if (this.wallpaperPortrait !== hash.wallpaperPortrait) {
      this.wallpaperPortrait = hash.wallpaperPortrait;
    }
    if (this.wallpaperLandscape !== hash.wallpaperLandscape) {
      this.wallpaperLandscape = hash.wallpaperLandscape;
    }
    if (this.useWallpapers !== hash.useWallpapers) {
      this.useWallpapers = hash.useWallpapers;
    }
    if (this.online !== hash.online) {
      this.online = hash.online;
    }
    if (this.allowPasskeys !== hash.allowPasskeys) {
      this.allowPasskeys = hash.allowPasskeys;
    }
  }
}
